export default __webpack_public_path__ + "static/media/logo-slogan.968c93dd.png";